// @flow
import * as React from 'react'
import styled from 'styled-components'
import tw from 'tailwind-styled-components'
import Flex from 'ui/atoms/Flex'
import { Alert } from 'ui/Icons'

type BannerProps = {
  /** Set the banner to sticky style */
  $sticky?: boolean,
  /** Set the banner to warning style */
  $warning?: boolean,
  /** Set the banner to center text style */
  $centerText?: boolean,
  /** Set the banner to compact style */
  $compact?: boolean,
  /** Banner content */
  children: React.Node,
  /** Truncate the banner content */
  truncate?: boolean,
  /** Show an icon in the banner */
  withIcon?: boolean,
}

const StyledAlertWrapper = styled.div`
  transform: scale(0.6);
`

const StyledBanner: React.ComponentType<BannerProps> = tw.div`
  text-officeUseBorder
  p-2.5
  mt-3
  rounded-lg

  bg-gray-100
  ${({ $compact }: BannerProps) => {
    if (!$compact) return ''

    return `
      p-0
      text-sm
    `
  }}

  ${(props: BannerProps) => {
    if (props.$centerText) {
      return 'text-center'
    }

    return ''
  }}

  ${(props: BannerProps) => {
    if (props.$warning) {
      return `
        bg-officeUseBackgroundHover
        border-officeUseBorder
        border-2
        border-solid
      `
    }

    return ''
  }}

  ${(props: BannerProps) => {
    if (props.$sticky) {
      return `
        w-7/12
        mx-auto
        sticky
        z-10
        top-0
      `
    }

    return ''
  }}
`

/** A banner */
function Banner({
  children,
  withIcon,
  truncate,
  ...rest
}: BannerProps): React.Node {
  return (
    <StyledBanner {...rest}>
      <Flex align="center">
        {withIcon && (
          <StyledAlertWrapper>
            <Alert fill="currentColor" size={15} />
          </StyledAlertWrapper>
        )}
        <span className={truncate ? 'truncate' : ''}>{children}</span>
      </Flex>
    </StyledBanner>
  )
}

export default Banner
